"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type SectionLanguage = "en" | "it";
const galleryItems = [{
  id: 1,
  src: "https://saraandmichael2026.com/wp-content/uploads/2026/04/image000001.jpeg?v=0rzd682lfczb",
  alt: {
    en: "Sunlight through Roman pines at Villa Borghese",
    it: "La luce del sole tra i pini romani a Villa Borghese"
  },
  caption: {
    en: "Airplane, on our way to Rome (probably)",
    it: "In aereo, in viaggio verso Roma (probabilmente)"
  },
  aspect: "aspect-[3/4]"
}, {
  id: 2,
  src: "https://saraandmichael2026.com/wp-content/uploads/2026/04/IMG_9109-scaled.jpg?v=a5n5mm9y16",
  alt: {
    en: "Strolling through the cobblestone streets of Trastevere",
    it: "Passeggiando tra le strade acciottolate di Trastevere"
  },
  caption: {
    en: "Castel Gandolfo, IT",
    it: "Castel Gandolfo, IT"
  },
  aspect: "aspect-[16/9]"
}, {
  id: 3,
  src: "https://saraandmichael2026.com/wp-content/uploads/2026/04/WhatsApp-Image-2026-04-12-at-2.39.53-PM.jpeg?v=pmy158rcbtm",
  alt: {
    en: "A quiet moment by a hidden Roman fountain",
    it: "Un momento tranquillo accanto a una fontana nascosta di Roma"
  },
  caption: {
    en: "Atlanta, GA (our first trip!)",
    it: "Atlanta, GA (il nostro primo viaggio!)"
  },
  aspect: "aspect-square"
}, {
  id: 4,
  src: "https://saraandmichael2026.com/wp-content/uploads/2026/04/IMG_0087-scaled.jpg?v=02txni2z80x5",
  alt: {
    en: "Ancient Roman arches framing the sunset",
    it: "Antichi archi romani che incorniciano il tramonto"
  },
  caption: {
    en: "London, UK",
    it: "Londra, Regno Unito"
  },
  aspect: "aspect-[4/3]"
}, {
  id: 5,
  src: "https://saraandmichael2026.com/wp-content/uploads/2026/04/IMG_9722-scaled.jpg?v=0axn5zb6yfkp",
  alt: {
    en: "Toasting to the future on a Roman rooftop terrace",
    it: "Un brindisi al futuro su una terrazza romana"
  },
  caption: {
    en: "Edinburgh, UK",
    it: "Edimburgo, Regno Unito"
  },
  aspect: "aspect-[3/4]"
}, {
  id: 6,
  src: "https://saraandmichael2026.com/wp-content/uploads/2026/04/IMG_9787-scaled.jpg?v=beiglr12un",
  alt: {
    en: "Walking along the banks of the Tiber River at dusk",
    it: "Passeggiando lungo il Tevere al tramonto"
  },
  caption: {
    en: "Matera, IT",
    it: "Matera, IT"
  },
  aspect: "aspect-[4/3]"
}, {
  id: 7,
  src: "https://saraandmichael2026.com/wp-content/uploads/2026/04/WhatsApp-Image-2026-04-12-at-2.39.52-PM.jpeg?v=skmoyzrn80d",
  alt: {
    en: "Walking along the banks of the Tiber River at dusk",
    it: "Passeggiando lungo il Tevere al tramonto"
  },
  caption: {
    en: "Polignano a Mare, IT",
    it: "Polignano a Mare, IT"
  },
  aspect: "aspect-[3/4]"
}, {
  id: 8,
  src: "https://saraandmichael2026.com/wp-content/uploads/2026/04/WhatsApp-Image-2026-04-12-at-2.48.16-PM.jpeg?v=hvrcaeiycb",
  alt: {
    en: "Walking along the banks of the Tiber River at dusk",
    it: "Passeggiando lungo il Tevere al tramonto"
  },
  caption: {
    en: "Michael's comfy plane outfit",
    it: "L'outfit comodo di Michael per l'aereo"
  },
  aspect: "aspect-square"
}, {
  id: 9,
  src: "https://saraandmichael2026.com/wp-content/uploads/2026/04/IMG_1598-scaled.jpg?v=5zs5krvcnr6",
  alt: {
    en: "Walking along the banks of the Tiber River at dusk",
    it: "Passeggiando lungo il Tevere al tramonto"
  },
  caption: {
    en: "Lounge, New Orleans Airport",
    it: "Lounge, aeroporto di New Orleans"
  },
  aspect: "aspect-[16/9]"
}];
export default function TheRhythmOfCaparica() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: galleryRef,
    isVisible: isGalleryVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  const [language, setLanguage] = useState<SectionLanguage>("en");
  useEffect(() => {
    const savedLanguage = localStorage.getItem("site-language");
    if (savedLanguage === "en" || savedLanguage === "it") {
      setLanguage(savedLanguage);
    }
  }, []);
  useEffect(() => {
    const handleStorageChange = () => {
      const savedLanguage = localStorage.getItem("site-language");
      if (savedLanguage === "en" || savedLanguage === "it") {
        setLanguage(savedLanguage);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("focus", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("focus", handleStorageChange);
    };
  }, []);
  const t = {
    en: {
      heading: "Travel Pictures",
      subheading: "For your pleasure :)",
      view: "View"
    },
    it: {
      heading: "Foto di Viaggio",
      subheading: "Per il vostro piacere :)",
      view: "Vedi"
    }
  }[language];
  return <section id="capturing-the-romance" className="bg-background py-24 lg:py-32 overflow-hidden text-foreground">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={headerRef} className={`mb-16 max-w-2xl transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground mb-6 tracking-tighter">
            {t.heading}
          </h2>
          <p className="font-sans text-muted-foreground text-lg leading-relaxed max-w-xl">
            {t.subheading}
          </p>
        </div>

        <div ref={galleryRef} className={`columns-1 md:columns-2 lg:columns-3 gap-10 space-y-10 transition-all duration-1000 delay-200 ease-out ${isGalleryVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid relative group overflow-hidden rounded-tl-[3rem] bg-muted/30 shadow-sm">
              <div className={`relative w-full overflow-hidden ${item.aspect}`}>
                <img src={item.src} alt={item.alt[language]} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
              </div>

              <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out pointer-events-none" />

              <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-all duration-500 delay-100 ease-out translate-y-2 group-hover:translate-y-0 pointer-events-none">
                <p className="font-sans text-[10px] uppercase font-bold text-primary-foreground tracking-[0.2em] bg-primary/90 px-4 py-2 backdrop-blur-sm shadow-md">
                  {t.view} — {item.caption[language]}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}